// src/components/user-menu/UserMenu.jsx
import { useEffect, useMemo, useState } from "react";
import { Avatar, Popover, Select, Spin } from "antd";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { getCliniciansByIds } from "../../../services/api";
import { useNavigate } from "react-router-dom";
import { formatClinicianName } from "../../../utils/formatClinicianName";

export { formatClinicianName };

export const UserMenu = ({
  user,
  onLogout,
  selectedDoctorId,
  onSelectDoctor,
  options,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [avatarSrcFailed, setAvatarSrcFailed] = useState(false);

  const REDIRECT_TO = "/";

  const onSessionPage = (() => {
    const p = (location.pathname || "").toLowerCase();
    return p.startsWith("/patient") || p.startsWith("/patients");
  })();

  const handleChange = (val) => {
    onSelectDoctor?.(val);
    setOpen(false);
    if (onSessionPage) {
      navigate(REDIRECT_TO, { replace: true });
    }
  };

  const content = (
    <div className="min-w-[240px]">
      <div className="px-4 py-3">
        {/* <div className="text-xs text-gray-500 mb-1">Switch Doctor</div> */}
        {loading ? (
          <>
          <Spin tip="Loading user menus..."/>
          <p className="mt-4 text-gray-500 text-sm font-medium">Loading user menus...</p>
          </>
          
          
        ) : (
          <>{formatClinicianName(options)}</>
        )}
      </div>
      <div className="my-2 border-t border-gray-200" />
      <div
        className="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer"
        onClick={() => { setOpen(false); navigate("/profile"); }}
        aria-label="Profile"
      >
        <UserOutlined />
        <span className="ml-2">Profile</span>
      </div>
      <div
        className="flex items-center px-4 py-2 hover:bg-gray-100 cursor-pointer"
        onClick={onLogout}
      >
        <LogoutOutlined />
        <span className="ml-2">Logout</span>
      </div>
    </div>
  );

  // const selectedDoc = options.find((o) => o.value === selectedDoctorId);
  const displayName = formatClinicianName(options);
  // Use the presigned avatar_url when present; fall back to /img/avatar.jpg.
  const displayAvatar = options?.avatar_url || "/img/avatar.jpg";
  // Reset the failure flag whenever the src candidate changes (e.g. new upload).
  useEffect(() => { setAvatarSrcFailed(false); }, [displayAvatar]);
  // Show the first initial when the image fails to load at runtime.
  const nameInitial = displayName?.charAt(0) || null;

  return (
    <Popover
      content={content}
      placement="bottomRight"
      trigger="click"
      className="cursor-pointer"
      open={open}
      onOpenChange={setOpen}
    >
      <div className="flex items-center">
        <Avatar
          src={avatarSrcFailed ? undefined : displayAvatar}
          onError={() => { setAvatarSrcFailed(true); return false; }}
          className="select-none w-10 h-10"
        >
          {nameInitial}
        </Avatar>
        <span className="text-white font-inter text-[14px] leading-[20px] font-medium ml-2 select-none">
          {displayName}
        </span>
      </div>
    </Popover>
  );
};
